function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWebtelcoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 232.6 171.9",
    style: {
      enableBackground: "new 0 0 232.6 171.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M127.6,86.3c0,11.1,0,21.5,0,32c0,12.7,0,25.3-0.2,38c-0.1,5.2-3.3,8.9-8.1,10.2c-4.9,1.3-9.3-0.1-11.9-4.2 c-1.6-2.5-2.2-5.9-2.2-8.9c-0.2-20.7-0.1-41.3-0.1-62c0-1.6,0-3.3,0-5.1C92.3,84.1,80.8,80,70.5,72.8c-6.5-4.5-8.5-11.2-4.7-16.6 c3.9-5.7,10.4-6.5,17.2-2.2c22.2,14,44.5,14,66.7,0c6.8-4.3,13.3-3.5,17.2,2.1c3.8,5.5,1.9,12.1-4.6,16.6 C151.9,79.9,140.4,84.1,127.6,86.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M88.1,150.3c0.1,7.4-6.5,13-13.8,11.1c-23.6-6.1-44.6-17.4-63.1-33.2c-5.3-4.5-5.7-11.3-1.7-16.1 c4.2-5,10.8-5.5,16.4-0.9c15.6,12.8,32.9,22.4,52.5,28C85,141.1,88,144.9,88.1,150.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M157,161.7c-6.3,0.1-11-3.5-12.2-8.7c-1.3-5.6,1.3-10.7,6.8-12.9c8.2-3.2,16.9-5.4,24.6-9.5 c10.2-5.5,19.9-12.1,29.4-18.7c6.9-4.8,13.3-5.1,17.7,0.4c4.3,5.4,2.9,12.2-3.5,17.4c-17.7,14.3-37.3,25-59.3,31.1 C159.1,161.2,157.7,161.5,157,161.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M136.6,25.3c0.1,11.2-8.9,20.4-20.1,20.5c-11.1,0.1-20.4-9-20.5-20.2C96,13.9,104.8,5,116.4,5 C127.8,5,136.5,13.8,136.6,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M82.3,98.8c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2-0.1-0.2-0.1C82,98.6,82.2,98.7,82.3,98.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M197.7,92.5c-0.4,3.4-2.2,5.5-5.7,8.2c-0.3,0.2-0.6,0.4-0.9,0.7c-8.8,7.2-18.7,12.9-29.4,17h0 c-0.7,0.3-1.3,0.5-2,0.7c-6,2.2-12.2-0.6-14.4-6.2c-1.8-4.4-0.5-9.1,2.8-12.3c0,0,0.1-0.1,0.1-0.1c0.9-0.8,1.9-1.6,3-2.2 c9.3-5.1,18.5-10.4,27.6-15.8c1.4-0.8,2.7-1.5,4.1-1.9c0.2-0.1,0.4-0.1,0.7-0.2c0.1,0,0.2-0.1,0.4-0.1c1-0.2,2.1-0.3,3.1-0.3 c0.2,0,0.4,0,0.5,0c3.5,0.3,6.8,2.4,8.7,5.7c0.5,1,0.9,2,1.2,3.1C197.8,90,197.9,91.3,197.7,92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M86.9,114.2c-2.9,5.2-9.4,7.2-14.7,4.7c-12.2-4.4-23.2-11-33.1-19.3c0,0-0.1-0.1-0.1-0.1 c-0.2-0.2-0.4-0.3-0.5-0.5c-0.2-0.2-0.4-0.4-0.6-0.6c-0.2-0.2-0.3-0.4-0.5-0.6c-0.1-0.2-0.3-0.4-0.4-0.5c0,0,0-0.1-0.1-0.1 c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.3-0.3-0.6-0.5-0.9c-0.1-0.2-0.2-0.4-0.2-0.6c-0.1-0.2-0.1-0.3-0.2-0.5 c-1.1-3.4-0.6-7.3,1.8-10.3c3.6-4.7,9.7-5.6,15.2-2.4c0.4,0.2,0.7,0.4,1.1,0.6c0,0,0,0,0,0c9.3,5.4,18.7,10.7,28,16.1 c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.1,0.1,0.2,0.1c2.9,1.6,4.8,4.4,5.5,7.4c0,0.2,0.1,0.3,0.1,0.5 C88.6,109.2,88.2,111.8,86.9,114.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWebtelcoSmall);
export default __webpack_public_path__ + "static/media/logo_webtelco_small.1db3b05cbedeb6296f9d7da4fdb170b7.svg";
export { ForwardRef as ReactComponent };